import { css } from '@/styled-system/css';

export const card = css({
  borderRadius: 'md',
  background: 'bg.softest',
  padding: 'default',
  width: '100%',
});

export const heading = css({
  fontSize: 'body-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
  letterSpacing: 'body-sm',
  lineHeight: 'body-sm',
  margin: 0,
  marginBottom: 'default',
});

export const grid = css({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: 'default',
  rowGap: 'default',
});

export const factRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '150',
  minWidth: 0,
});

export const factIcon = css({
  color: 'text.subtle',
  flexShrink: 0,
});

export const factLabel = css({
  fontSize: 'body-sm',
  fontWeight: 'regular',
  color: 'text.subtle',
  letterSpacing: 'body-sm',
  lineHeight: 'body-sm',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const toggle = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'tightest',
  marginTop: 'tighter',
  padding: 0,
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontSize: 'body-sm',
  fontWeight: 'bold',
  color: 'brand.primary',
  letterSpacing: 'body-sm',
  lineHeight: 'body-sm',
  _hover: {
    color: 'brand.primaryHover',
  },
});
